import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import Context from '../../../utils/context';
import SignUp from '../../sign_up';
import PatientOrCaregiver from './patient_or_caregiver';
import Age from '../age/age';
import Gender from './gender';
import Diagnosis from './diagnosis';
import LastSeisure from './last_seisure';
import SeisureFrequency from './seisure_frequency';
import Prescription from './prescription';
import SymptomManagement from './symptom_management';
import AsmSideEffect from './asm_side_effect';
import ConsideringASwitch from './considering_a_switch';
import ReasonForSwitch from './reason_for_switch';
import MentorConversationTopics from './mentor_conversation_topics';
import LoadingScreen from '../../loading_screen';
import MentorMatch from '../../surgeon/referred_mentor_match/pre_conversation_questionnaire/mentor_match';
import QuestionnaireStopper from '../questionnaire_stopper';
import { getSurgeonReferredMentorMatchFromProfile } from './../../../api/profiles';
import {
  createSurgeonReferredMentorMatch,
  updateSurgeonReferredMentorMatch,
} from '../../../api/surgeon_referred_mentor_matches';
import { findAndSetMentor } from '../../../helpers/find_mentor_helper';
import { arrayCompact } from '../../../helpers';
import styles from './index.module.css';

export default function XcopriQuestionnaire({
  standAlone = false,
  backgroundColor = '#f5f7f9',
  headerContent = <></>,
  signupHeadline = 'Get matched to your PatientPartner mentor!',
  useFormWrapper = false,
}) {
  const context = useContext(Context);
  const history = useHistory();
  const [view, setView] = useState('sign-up');
  const [xcopriPatientOrCaregiver, setXcopriPatientOrCaregiver] = useState();
  const [currentBirthday, setCurrentBirthday] = useState(
    context.auth.isLoggedIn() ? context.auth.getCurrentUser().date_of_birth : null
  );
  const [patientDateOfBirth, setPatientDateOfBirth] = useState();
  const [gender, setGender] = useState();
  const [xcopriDiagnosis, setXcopriDiagnosis] = useState();
  const [xcopriLastSeisure, setXcopriLastSeisure] = useState();
  const [xcopriSeisureFrequency, setXcopriSeisureFrequency] = useState();
  const [xcopriPrescription, setXcopriPrescription] = useState();
  const [xcopriSymptomManagement, setXcopriSymptomManagement] = useState();
  const [xcopriAsmSideEffect, setXcopriAsmSideEffect] = useState();
  const [xcopriConsideringASwitch, setXcopriConsideringASwitch] = useState();
  const [xcopriReasonForSwitch, setXcopriReasonForSwitch] = useState();
  const [mentorConversationTopics, setMentorConversationTopics] = useState();
  const [surgeonReferredMentorMatch, setSurgeonReferredMentorMatch] = useState();
  const [patientPartner, setPatientPartner] = useState();
  const [mentorFound, setMentorFound] = useState(false);

  const update = (params, callback) => {
    updateSurgeonReferredMentorMatch(surgeonReferredMentorMatch.uuid, params, (data) => {
      setSurgeonReferredMentorMatch(data);
      callback();
    });
  };

  const calculateAge = (dob) => {
    const today = new Date();
    const birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    // If the current date is before the birthday this year, subtract one from the age
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age;
  };

  useEffect(() => {
    if (context.auth.isLoggedIn()) {
      getSurgeonReferredMentorMatchFromProfile((match) => {
        setSurgeonReferredMentorMatch(match);
        setView('patient-or-caregiver');
      });
    }
  }, []);

  useEffect(() => {
    if (mentorFound && patientPartner) {
      setView('patient-partner');
    }
  }, [mentorFound, patientPartner]);

  const scrollToQuestionnaire = (useDelay) => {
    const scrollFunc = () => {
      const timer = setTimeout(() => {
        document.getElementById('questionnaire-scroll-to').scrollIntoView({
          behavior: 'smooth',
        });
      }, 100);
      return () => clearTimeout(timer);
    };

    if (useDelay) {
      setTimeout(scrollFunc, 1000);
    } else {
      scrollFunc();
    }
  };

  const afterSignUp = (user) => {
    createSurgeonReferredMentorMatch({ surgeon_id: gon.xcopri_surgeon_id, surgery: 'Epilepsy Rx' }, (match) => {
      setSurgeonReferredMentorMatch(match);
      setView('patient-or-caregiver');
      scrollToQuestionnaire();
    });
  };

  let bgCss = { maxWidth: '100%' };
  if (backgroundColor) {
    bgCss['backgroundColor'] = backgroundColor;
  }

  const FormWrapper = ({ children, addCol, headerContent }) => {
    if (useFormWrapper) {
      if (addCol) {
        return (
          <div className={'col'}>
            {headerContent}
            <div
              className={'registrations-container'}
              style={{ backgroundColor: 'rgb(255, 255, 255)', boxShadow: 'none', marginTop: '20px' }}
            >
              {children}
            </div>
          </div>
        );
      }

      return (
        <>
          {headerContent}
          <div
            className={'registrations-container'}
            style={{ backgroundColor: 'rgb(255, 255, 255)', boxShadow: 'none', marginTop: '20px' }}
          >
            {children}
          </div>
        </>
      );
    }

    return children;
  };

  return (
    <div
      id={`questionnaire-scroll-to`}
      className={`${styles.questionnaire_ottr} patient-partner-questionnaire container text-left ${view === 'loading-surgeon' ? 'fixedHeight' : ''} h-100 de-pad`}
      style={bgCss}
    >
      <div
        style={{
          alignContent: 'center',
          minHeight: standAlone ? '87vh' : '20vh',
          padding: standAlone ? '0px' : '75px 0px',
        }}
        className='row h-100 questionnaire-content h-100'
      >
        {view !== 'surgeon' && (
          <div className={`container h-100`}>
            <div className={`row h-100 ${styles.cont_row}`}>
              <div className='col-md-2'></div>
              <div className={`col-md-8 fadeOp`} style={{ flex: '0 0 100%', maxWidth: '100%' }}>
                {headerContent}
                {view === 'sign-up' && (
                  <SignUp
                    onSuccess={afterSignUp}
                    params={{
                      keap_force_sync: true,
                      origin: 'Xcopri Landing Page',
                      procedure: 'Epilepsy',
                      surgery: 'Epilepsy Rx',
                    }}
                    headline={signupHeadline}
                    para={`Let’s create your account to get started.`}
                    embedded
                    alignLeft
                    light={false}
                    captureFirstLastName
                    captureLocation
                  />
                )}
                {view === 'patient-or-caregiver' && (
                  <FormWrapper>
                    <PatientOrCaregiver
                      answers={{ xcopriPatientOrCaregiver: xcopriPatientOrCaregiver }}
                      onSubmit={(answers) => {
                        setXcopriPatientOrCaregiver(answers.xcopriPatientOrCaregiver);
                        update({ xcopri_patient_or_caregiver: answers.xcopriPatientOrCaregiver }, () => {
                          setView('age');
                          scrollToQuestionnaire();
                        });
                      }}
                    />
                  </FormWrapper>
                )}
                {view === 'age' && (
                  <FormWrapper>
                    <Age
                      title='What is your date of birth?'
                      para=''
                      answers={{ date_of_birth: currentBirthday }}
                      onSubmit={(answers) => {
                        setCurrentBirthday(answers.date_of_birth);
                        context.auth.userUpdate({ date_of_birth: answers.date_of_birth }, () => {
                          if (xcopriPatientOrCaregiver === 'Patient') {
                            const age = calculateAge(answers.date_of_birth);
                            if (age < 18) {
                              setView('thank-you');
                            } else {
                              setView('gender');
                            }
                            scrollToQuestionnaire();
                          } else {
                            setView('patient-age');
                            scrollToQuestionnaire();
                          }
                        });
                      }}
                      onBack={() => setView('patient-or-caregiver')}
                      gtm={''}
                      cta='Next'
                    />
                  </FormWrapper>
                )}
                {view === 'patient-age' && (
                  <FormWrapper>
                    <Age
                      title='If you are a caregiver, what is the patient’s date of birth?'
                      para=''
                      answers={{ date_of_birth: patientDateOfBirth }}
                      onSubmit={(answers) => {
                        setPatientDateOfBirth(answers.date_of_birth);
                        update({ xcopri_patient_dob: answers.date_of_birth }, () => {
                          const age = calculateAge(answers.date_of_birth);
                          if (age < 18) {
                            setView('thank-you');
                          } else {
                            setView('gender');
                          }
                          scrollToQuestionnaire();
                        });
                      }}
                      onBack={() => setView('age')}
                      gtm={''}
                      cta='Next'
                    />
                  </FormWrapper>
                )}
                {view === 'thank-you' && (
                  <QuestionnaireStopper
                    para={
                      <div>
                        <p>
                          We understand how important it is to find support, but the XCOPRI PatientPartner Mentor
                          Program is only available for patients who are 18 years or older. If you're a caregiver or if
                          the patient you're enrolling is under 18, we're unable to complete the registration at this
                          time.
                        </p>
                        <br />
                        <p>
                          If you would like to learn more, please check out the XCOPRI Resource Center by clicking{' '}
                          <a
                            style={{ fontFamily: 'HK Grotesk', fontSize: '18px', color: '#0000FF' }}
                            href='https://www.xcopri.com/epilepsy-resources/#resources'
                            target='_blank'
                          >
                            here
                          </a>
                          .
                        </p>
                      </div>
                    }
                    header='Thank you for your interest!'
                  />
                )}
                {view === 'gender' && (
                  <FormWrapper>
                    <Gender
                      answers={{ gender: gender }}
                      onSubmit={(answers) => {
                        setGender(answers.gender);
                        context.auth.userUpdate({ gender: answers.gender }, () => {
                          setView('diagnosis');
                          scrollToQuestionnaire();
                        });
                      }}
                      onBack={() => {
                        if (xcopriPatientOrCaregiver === 'Patient') {
                          setView('age');
                        } else {
                          setView('patient-age');
                        }
                      }}
                    />
                  </FormWrapper>
                )}
                {view === 'diagnosis' && (
                  <FormWrapper>
                    <Diagnosis
                      answers={{ xcopriDiagnosis: xcopriDiagnosis }}
                      onSubmit={(answers) => {
                        setXcopriDiagnosis(answers.xcopriDiagnosis);
                        update({ xcopri_diagnosis: answers.xcopriDiagnosis }, () => {
                          setView('last-seisure');
                          scrollToQuestionnaire();
                        });
                      }}
                      onBack={() => setView('gender')}
                    />
                  </FormWrapper>
                )}
                {view === 'last-seisure' && (
                  <FormWrapper>
                    <LastSeisure
                      answers={{ xcopriLastSeisure: xcopriLastSeisure }}
                      onSubmit={(answers) => {
                        setXcopriLastSeisure(answers.xcopriLastSeisure);
                        update({ xcopri_last_seisure: answers.xcopriLastSeisure }, () => {
                          setView('seisure-frequency');
                          scrollToQuestionnaire();
                        });
                      }}
                      onBack={() => setView('diagnosis')}
                    />
                  </FormWrapper>
                )}
                {view === 'seisure-frequency' && (
                  <FormWrapper>
                    <SeisureFrequency
                      answers={{ xcopriSeisureFrequency: xcopriSeisureFrequency }}
                      onSubmit={(answers) => {
                        setXcopriSeisureFrequency(answers.xcopriSeisureFrequency);
                        update({ xcopri_seisure_frequency: answers.xcopriSeisureFrequency }, () => {
                          setView('prescription');
                          scrollToQuestionnaire();
                        });
                      }}
                      onBack={() => setView('last-seisure')}
                    />
                  </FormWrapper>
                )}
                {view === 'prescription' && (
                  <FormWrapper>
                    <Prescription
                      answers={{ xcopriPrescription: xcopriPrescription }}
                      onSubmit={(answers) => {
                        setXcopriPrescription(answers.xcopriPrescription);
                        update({ xcopri_prescription: answers.xcopriPrescription }, () => {
                          if (answers.xcopriPrescription === 'Yes') {
                            setView('symptom-management');
                            scrollToQuestionnaire();
                          } else {
                            setView('considering-a-switch');
                            scrollToQuestionnaire();
                          }
                        });
                      }}
                      onBack={() => setView('seisure-frequency')}
                    />
                  </FormWrapper>
                )}
                {view === 'symptom-management' && (
                  <FormWrapper>
                    <SymptomManagement
                      answers={{ xcopriSymptomManagement: xcopriSymptomManagement }}
                      onSubmit={(answers) => {
                        setXcopriSymptomManagement(answers.xcopriSymptomManagement);
                        update({ xcopri_symptom_management: answers.xcopriSymptomManagement }, () => {
                          setView('asm-side-effects');
                          scrollToQuestionnaire();
                        });
                      }}
                      onBack={() => setView('prescription')}
                    />
                  </FormWrapper>
                )}
                {xcopriPrescription === 'Yes' && view === 'asm-side-effects'
                  ? setView('mentor-conversation-topics')
                  : view === 'asm-side-effects' && (
                      <FormWrapper>
                        <AsmSideEffect
                          answers={{ xcopriAsmSideEffect: xcopriAsmSideEffect }}
                          onSubmit={(answers) => {
                            let result = answers['xcopriAsmSideEffect'].concat([answers['other']]);
                            result = arrayCompact(result);
                            setXcopriAsmSideEffect(result);
                            update({ xcopri_asm_side_effect: result }, () => {
                              setView('mentor-conversation-topics');
                              scrollToQuestionnaire();
                            });
                          }}
                          onBack={() => {
                            if (xcopriConsideringASwitch === 'Yes' || xcopriConsideringASwitch === 'Maybe') {
                              setView('reason-for-switch');
                            } else if (xcopriConsideringASwitch === 'No') {
                              setView('considering-a-switch');
                            } else {
                              setView('symptom-management');
                            }
                          }}
                        />
                      </FormWrapper>
                    )}
                {view === 'considering-a-switch' && (
                  <FormWrapper>
                    <ConsideringASwitch
                      answers={{ xcopriConsideringASwitch: xcopriConsideringASwitch }}
                      onSubmit={(answers) => {
                        setXcopriConsideringASwitch(answers.xcopriConsideringASwitch);
                        update({ xcopri_considering_a_switch: answers.xcopriConsideringASwitch }, () => {
                          if (
                            answers.xcopriConsideringASwitch === 'Yes' ||
                            answers.xcopriConsideringASwitch === 'Maybe'
                          ) {
                            setView('reason-for-switch');
                            scrollToQuestionnaire();
                          } else {
                            setView('asm-side-effects');
                            scrollToQuestionnaire();
                          }
                        });
                      }}
                      onBack={() => setView('prescription')}
                    />
                  </FormWrapper>
                )}
                {view === 'reason-for-switch' && (
                  <FormWrapper>
                    <ReasonForSwitch
                      answers={{ xcopriReasonForSwitch: xcopriReasonForSwitch }}
                      onSubmit={(answers) => {
                        let result = answers['xcopriReasonForSwitch'].concat([answers['other']]);
                        result = arrayCompact(result);
                        setXcopriReasonForSwitch(result);
                        update({ xcopri_reason_for_switch: result }, () => {
                          setView('asm-side-effects');
                          scrollToQuestionnaire();
                        });
                      }}
                      onBack={() => setView('considering-a-switch')}
                    />
                  </FormWrapper>
                )}
                {view === 'mentor-conversation-topics' && (
                  <FormWrapper>
                    <MentorConversationTopics
                      answers={{ mentorConversationTopics: mentorConversationTopics }}
                      onSubmit={(answers) => {
                        setMentorConversationTopics(answers.mentorConversationTopics);
                        updateSurgeonReferredMentorMatch(
                          surgeonReferredMentorMatch.uuid,
                          { conversation_topics: answers.mentorConversationTopics },
                          () => {
                            setView('loading-patient-partner');
                            findAndSetMentor(
                              {
                                onSetPatientPartner: setPatientPartner,
                                onMentorFound: setMentorFound,
                              },
                              context
                            );
                          }
                        );
                      }}
                      onBack={() => {
                        if (xcopriPrescription === 'Yes') {
                          setView('symptom-management');
                        } else {
                          setView('asm-side-effects');
                        }
                      }}
                    />
                  </FormWrapper>
                )}
                {view === 'loading-patient-partner' && (
                  <FormWrapper>
                    <LoadingScreen
                      title={'Finding your mentor...'}
                      content={
                        'Get ready to meet a real patient who will answer your questions and support you through your journey!'
                      }
                    />
                  </FormWrapper>
                )}
                {view === 'patient-partner' && (
                  <FormWrapper>
                    <MentorMatch
                      patientPartner={patientPartner}
                      callback={(conversation) => {
                        updateSurgeonReferredMentorMatch(
                          surgeonReferredMentorMatch.uuid,
                          { conversation_id: conversation.id },
                          () => {
                            let firstMessage = '';
                            if (mentorConversationTopics && mentorConversationTopics.length > 0) {
                              if (mentorConversationTopics.length === 1 || mentorConversationTopics.length === 2) {
                                firstMessage =
                                  'Hi ' +
                                  patientPartner.name +
                                  ', I would like to chat about ' +
                                  (mentorConversationTopics || []).join(' and ').toLowerCase();
                              } else {
                                firstMessage =
                                  'Hi ' +
                                  patientPartner.name +
                                  ', I would like to chat about ' +
                                  (mentorConversationTopics || []).slice(0, -1).join(', ').toLowerCase() +
                                  ' and ' +
                                  mentorConversationTopics[mentorConversationTopics.length - 1].toLowerCase();
                              }
                            }
                            history.push(`/member/conversations/${conversation.uuid}?firstMessage=${firstMessage}`);
                          }
                        );
                      }}
                      whatsNextMessage={(p) => {
                        return `Send your first message to ${p.name} and get answers to questions about their experience.`;
                      }}
                    />
                  </FormWrapper>
                )}
              </div>
              <div className='col-md-2'></div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
